import React from 'react';
import {Box, Grid, Button, Stack} from '@mui/material';
import Check from '@mui/icons-material/Check';
import './pricing.css';

import FormManager from '../../../components/formComponents/FormManager';
import schema from './schema.json'; 
import HTTPManager from '../../../utils/httpRequestManager';

export default class MerchantRegister extends React.Component{
    httpManager = new HTTPManager()
    constructor(){
        super();
        this.state={
            schema:{},
//             planlist:[{
//                 id:'123',
//                 planName:'Basic',
//                 planFee:'0.00',
//                 features:[
//                     'Create Ticket',

// 'Tip Adjustment',

// 'Appointment',
// 'Daily Report Owner',

// 'Daily Report Employee',

// 'Printing Receipt and reports'


//                 ]
//             }],
planlist:[],
            selectedPlan:'',
            previewplan:{
                id:'123',
                planName:'Basic',
                planFee:'0.00',
                planFeatures:[]
            },

        }
    }
    componentDidMount(){
        this.httpManager.getRequest('/plans/getActivePlans').then(r=>{
            console.log(r.data)
            this.setState({planlist: r.data})
        })
        this.setState({schema:schema})
    }

    render(){
        return <>  
            {this.state.selectedPlan === '' && <Box sx={{ width: '100%' }}> 
                        <div class="container group" style={{ marginTop: 20}}>
                        <Grid container spacing={3}  alignItems="center"  justifyContent="center" style={{marginLeft:0, marginRight:0,width:'100%', fontWeight:'bold'}} > 

                                {this.state.planlist.map((plan, i)=>{
                                return (
                                    <Grid item xs={12} sm={6} md={4} style={{paddingLeft:'0'}} onClick={()=>{
                                    this.setState({previewplan:plan})
                                    }}>  
                                        <div className={this.state.previewplan.id === plan.id ? "selected plandetails" : "plandetails"}>
                                            <div style={{padding:'1.5rem'}}>
                                                <img src={this.state.previewplan.id === plan.id ? '/static/icons/systemselect.svg' : '/static/icons/systemnotselect.svg'} alt='systemicon' className='planimg'/>
                                                <span class="plantitle">{plan.planName}</span>
                                                <span class="plantext">Start your account for free</span> 
                                            </div>
                                            <h1><span>${plan.planFee}/month</span></h1>
                                            {/* <h4 style={{padding:'0 1.5rem'}}><span>Key Features:</span></h4> */}
                                            <ul  style={{padding:'1.5rem'}}>
                                            {plan.planFeatures.map(feature=>{ 
                                                return <li className="priceli"><Check className='checkicon'/>
                                                {feature.feature}</li>
                                            })}
                                            </ul>
                                            <div style={{alignItems:'center',padding:'1.5rem', display:'flex', width:'100%'}}>
                                                <Button
                                                fullWidth
                                                size="large" 
                                                variant="contained"  className='signupbtn' onClick={()=>{
                                                    var props = []
                                                    this.state.schema.properties.forEach((p,i)=>{
                                                        if(p.name==='merchantPlanId'){
                                                            p.value=plan.id
                                                        }
                                                        props.push(p)
                                                        if(i === schema.properties.length-1){
                                                            var sch= Object.assign({}, schema)
                                                            sch.properties = props;
                                                            this.setState({schema:sch, selectedPlan: plan.id});
                                                        }
                                                    })
                                                }} >Start Account</Button>
                                            </div>
                                        </div>
                                    </Grid> )
                                })}
                                </Grid>
                        </div>
                    </Box>
            } 

            {this.state.selectedPlan !== '' && <Box sx={{ width: '100%' }}> 
                <Grid container spacing={3}  alignItems="center"  justifyContent="center" style={{marginLeft:0, marginRight:0,width:'100%', fontWeight:'bold'}} > 
                     <Grid item xs={1}></Grid>
                     <Grid item xs={10}>

                        <Stack spacing={3}>
                            <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="right" spacing={2}>
                                <Button  onClick={()=>this.goToPlan()} label="Go Back"/>  
                            </Stack> 
                            <FormManager formProps={this.state.schema} />
                        </Stack>
                    </Grid>
                    <Grid item xs={1}></Grid> 
                </Grid>
            </Box>}
        </>
    }
}